import { Injectable } from '@angular/core';
import Dexie from 'dexie';

@Injectable()
export class DexieService extends Dexie {
  constructor() {
    super('KeolisDatabase');
    this.version(1).stores({
      pks: 'id,number',
      measures: '[pk.id+bt.number+bt.indice],[bt.number+bt.indice]'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/dexie.service.ts